import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import firebase from "../../firebase/firebase-config";
import SingleAdCard from './SingleAdCard';


function AllAds() {
    const [query, setquery] = useState('')
    const [allAds, setAllAds] = useState([])
    const [allAdsPending, setallAdsPending] = useState([])
    const [allAdsDeclined, setallAdsDeclined] = useState([])
    const [allAdsExpired, setallAdsExpired] = useState([])
    const [allAdsApproved, setallAdsApproved] = useState([])
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getAllAds = async () => {
        await firebase.firestore().collection('Ads').orderBy('createdOnDate').onSnapshot((userAds) => {

            const allAdsData = [];
            userAds.forEach((dataAds) => {
                allAdsData.push(dataAds.data())
            })
            console.log(allAdsData);
            setAllAds(allAdsData);

        })
    }
    const getAllpendingAds = async () => {
        await firebase.firestore().collection('Ads').where('isAdVerified', '==', 'pending').onSnapshot((userAds) => {

            const allAdsPendingData = [];
            userAds.forEach((dataAds) => {
                allAdsPendingData.push(dataAds.data())
            })
            setallAdsPending(allAdsPendingData);

        })
    }

    const getAlldeclinedAds = async () => {
        await firebase.firestore().collection('Ads').where('isAdVerified', '==', 'declined').onSnapshot((userAds) => {

            const allAdsDeclinedData = [];
            userAds.forEach((dataAds) => {
                allAdsDeclinedData.push(dataAds.data())
            })
            setallAdsDeclined(allAdsDeclinedData);

        })
    }


    const getAllexpiredAds = async () => {
        await firebase.firestore().collection('Ads').where('isAdVerified', '==', 'expired').onSnapshot((userAds) => {

            const allAdsExpiredData = [];
            userAds.forEach((dataAds) => {
                allAdsExpiredData.push(dataAds.data())
            })
            setallAdsExpired(allAdsExpiredData);

        })
    }

    const getAllApprovedAds = async () => {
        await firebase.firestore().collection('Ads').where('isAdVerified', '==', 'approved').onSnapshot((userAds) => {

            const allAdsApprovedData = [];
            userAds.forEach((dataAds) => {
                allAdsApprovedData.push(dataAds.data())
            })
            setallAdsApproved(allAdsApprovedData);

        })
    }


    useEffect(() => {

        getAllAds();
        getAllpendingAds();
        getAllApprovedAds();
        getAlldeclinedAds();
        getAllexpiredAds();
    }, []);

    const search = (data) => {
        return data.filter((order_search) => order_search.orderId.toLowerCase().includes(query) || order_search.isCompleted.toLowerCase().includes(query) || order_search.products.toLowerCase().includes(query) || order_search.contact.toLowerCase().includes(query)

        );
    }
    return (
        <>
            <div className="content">
                <Row>
                    <Col xs="12">

                        <div className="row  d-flex justify-content-center align-items-center">

                            <div className="col-md-6">

                                <div className="form" style={{ position: 'relative' }}>
                                    {query == '' ? <i className="fa fa-search" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i> : <i className="fa fa-close" style={{ position: 'absolute', top: '20px', left: '20px', color: '#9ca3af' }}></i>}

                                    <input type="text" className="form-control form-input" placeholder="Search any Order..." value={query} onChange={(e) => setquery(e.target.value)} style={{
                                        height: '55px',
                                        textIndent: '33px',
                                        borderRadius: '10px'
                                    }} />
                                    <span className="left-pan" style={{
                                        position: 'absolute',
                                        right: '17px',
                                        top: '13px',
                                        padding: '2px',
                                        borderLeft: '1px solid #d1d5db',
                                    }}>
                                        {query == '' ?
                                            <i className="fa fa-microphone" style={{ paddingLeft: '10px' }}></i> : <i className="fa fa-search" style={{ paddingLeft: '10px' }}></i>}</span>

                                </div>

                            </div>

                        </div>


                    </Col>
                </Row>
                <Row className="d-flex justify-content-center  mt-4 align-items-center">
                    <button
                        className={toggleState === 1 ? "tabs active-tabs btn btn-primary btn-sm" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(1)}
                    >
                        All Ads({allAds?.length})
                    </button>
                    <button
                        className={toggleState === 2 ? "tabs active-tabs btn btn-primary btn-sm" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(2)}
                    >
                        Pending({allAdsPending?.length})
                    </button>
                    <button
                        className={toggleState === 3 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(3)}
                    >
                        Approved ({allAdsApproved?.length})
                    </button>
                    <button
                        className={toggleState === 4 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(4)}
                    >
                        Declined ({allAdsDeclined?.length})
                    </button>
                    <button
                        className={toggleState === 5 ? "tabs active-tabs btn btn-sm btn-primary" : "tabs btn-sm btn btn-default"}
                        onClick={() => toggleTab(5)}
                    >
                        Expired ({allAdsExpired?.length})
                    </button>

                </Row>

                <div className='mt-4'>
                    <div className="content-tabs">
                        <div className={toggleState === 1 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {allAds.filter(Ads => Ads.adsId.toLowerCase().includes(query)).map((AdsData, i) => (

                                    <SingleAdCard data={AdsData} key={i} />


                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 2 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {allAdsPending.filter(Ads => Ads.adsId.toLowerCase().includes(query)).map((AdsData, i) => (

                                    <SingleAdCard data={AdsData} key={i} />


                                ))}
                            </div>



                        </div>
                        <div className={toggleState === 3 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {allAdsApproved.filter(Ads => Ads.adsId.toLowerCase().includes(query)).map((AdsData, i) => (

                                    <SingleAdCard data={AdsData} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 4 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {allAdsDeclined.filter(Ads => Ads.adsId.toLowerCase().includes(query)).map((AdsData, i) => (

                                    <SingleAdCard data={AdsData} key={i} />


                                ))}
                            </div>
                        </div>
                        <div className={toggleState === 5 ? "tab_content  active-content" : "tab_content"}>
                            <div className="row">

                                {allAdsExpired.filter(Ads => Ads.adsId.toLowerCase().includes(query)).map((AdsData, i) => (

                                    <SingleAdCard data={AdsData} key={i} />


                                ))}
                            </div>
                        </div>


                    </div>

                </div>


            </div>
        </>
    )
}

export default AllAds;